/*
 * Редактирование кейсета - https://tanker.yandex-team.ru/project/direct-components/keyset/components%2FModalConfirm%2FModalConfirm.i18n.ts
 * Документация локализации - https://a.yandex-team.ru/arcadia/adv/frontend/docs/monorepo/i18n.md
 */
import { createI18n, createI18nRaw, createKeyset } from '@adv-frontend/l10n/src/i18n';
const keyset = createKeyset({
    Да: {
        ru: 'Да',
        en: 'Yes',
        tr: 'Evet',
        'zh-Hans': '是',
    },
    Нет: {
        ru: 'Нет',
        en: 'No',
        tr: 'Hayır',
        'zh-Hans': '否',
    },
});
export const i18n = createI18n(keyset);
export const i18nRaw = createI18nRaw(keyset);
